import React from 'react';
import GoogleAnalytics from 'react-ga';

if( process.env.NODE_ENV === 'production' ) GoogleAnalytics.initialize(process.env.REACT_APP_GA_CODE);

const withTracker = (WrappedComponent) => {

    const trackPage = (page) => {
        if( process.env.NODE_ENV !== 'production' ) return;
        GoogleAnalytics.set({ page });
        GoogleAnalytics.pageview(page);
    };

    return (props) => {
        const page = props.location.pathname;
        trackPage(page);

        return (
            <WrappedComponent {...props} />
        );
    };

};

export default withTracker;


// WEBPACK FOOTER //
// ./src/js/config/analytics.js